import Api from '@umu/umu-api';
import { fetchData } from '@umu/umu-fetch';
import { IResponse } from '@umu/umu-types';
import {
    ICarrousel,
    ICourseRecommend,
    ICircleRecommend,
    RecommendType,
} from 'market/@marketCommon/interface/recommend';

interface IOutput {
    'carrousel'?: ICarrousel[];
    'group-today_recommend'?: ICourseRecommend[];
    'circle-today_recommend'?: ICircleRecommend[];
}

interface IInput {
    modules?: string; // 可选carrousel（轮播图）today_recommend（今日推荐)
    obj_type?: RecommendType;
}

export const getMarketRecommend = (input?: IInput): Promise<IResponse<IOutput>> => {
    if (input && !input.modules) {
        input.modules = 'carrousel,today_recommend';
    } else if (!input) {
        input = {
            modules: 'carrousel,today_recommend',
        };
    }
    return fetchData(Api.Path.MARKET_RECOMMEND, input).then((res: IResponse<IOutput>) => {
        return res;
    });
};
